<template>
  <div class="themPage">
    <div>
      <el-card style="margin: 30px">
        <div style="display: flex;align-items: center">
          <el-button size="small" type="primary" @click="searchBtn">查询</el-button>
          <el-button size="small" type="success" @click="addBtn">新增</el-button>
          <el-button v-if="multipleSelection&&multipleSelection.length" @click="batchDeleteBtn" size="small" type="danger">批量删除</el-button>
        </div>

        <el-table
            size="small"
            tooltip-effect="dark"
            ref="multipleTable"
            :data="tableData"
            @selection-change="handleSelectionChange"
            border
            style="width: 100%;margin-top: 30px"
        >
          <el-table-column
              type="selection"
              align="center"
              width="55">
          </el-table-column>
          <el-table-column label="标题" prop="title" align="center"></el-table-column>
          <el-table-column label="类型" prop="notice_type" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.notice_type == '1' ? '举报' : '公告' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="落款" prop="sign" align="center"></el-table-column>
          <el-table-column label="发布时间" prop="release_date" align="center"></el-table-column>
          <el-table-column
              align="center"
              label="操作"
              width="300"
          >
            <template slot-scope="scope">
              <el-button size="small" @click="viewBtn(scope.row)" type="primary">详情</el-button>
              <el-button size="small" @click="editBtn(scope.row)" type="success">修改</el-button>
              <el-button size="small" @click="deleteBtn(scope.row)" type="danger">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="display: flex;justify-content: center;margin-top: 20px"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements">
        </el-pagination>
      </el-card>
    </div>

    <!--    删除的弹窗-->
    <a-modal
        title="提示"
        :visible="deleteDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="deleteCancel"
        @ok="deleteSubmit"
    >
      <div>{{ simpleDelete ? '是否删除该条记录？' : '是否删除当前所选中的记录？' }}</div>
    </a-modal>

    <a-modal
        :visible="addDialogState"
        cancel-text="取消"
        ok-text="确认"
        :title="dialogTitle"
        width="900px"
        @cancel="addCancel"
        @ok="addSubmit('ruleForm')"
    >
      <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="标题" prop="title">
          <el-input :readonly="dialogTitle === '详情'" v-model="ruleForm.title" style="width: 400px" size="small" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="落款" prop="sign">
          <el-input :readonly="dialogTitle === '详情'" v-model="ruleForm.sign" style="width: 400px" size="small" placeholder="请输入落款"></el-input>
        </el-form-item>
        <el-form-item label="发布日期" prop="releaseDate">
          <el-date-picker
              :disabled="dialogTitle === '详情'"
              size="small"
              style="width: 400px"
              v-model="ruleForm.releaseDate"
              type="date"
              placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="类型" prop="noticeType">
          <el-select :disabled="dialogTitle === '详情'" style="width: 400px" size="small" v-model="ruleForm.noticeType" placeholder="请选择类型">
            <el-option
                v-for="item in [{name:'举报',id: '1'},{name:'公告',id: '2'}]"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <quill-editor :disabled="dialogTitle === '详情'" ref="myQuillEditor" style="width: 700px;height: 400px;padding-bottom: 200px"
                        v-model="ruleForm.content" :options="editorOption"/>
        </el-form-item>
      </el-form>
    </a-modal>

  </div>
</template>

<script>
import moment from "moment";
import 'quill/dist/quill.snow.css'
import {Quill, quillEditor} from 'vue-quill-editor'
import {container, ImageExtend, QuillWatch} from 'quill-image-extend-module'
import {baseURL} from "@/api/config";

Quill.register('modules/ImageExtend', ImageExtend)
export default {
  components: {quillEditor},
  data() {
    return {
      pageNum: 1,
      pageSize: 20,
      tableData: [],
      totalElements: 0,
      deleteDialogState: false,
      deleteId: '',
      simpleDelete: false,//是单个删除还是多个删除
      addDialogState: false,
      dialogTitle: '',
      ruleForm: {
        id: null,
        title: '',
        content: '',
        sign: '',
        releaseDate: '',
        noticeType: ''
      },
      rules: {
        title: [{required: true, message: "请输入标题", trigger: "blur"}],
        content: [{required: true, message: "请输入内容", trigger: "blur"}],
        sign: [{required: true, message: "请输入落款", trigger: "blur"}],
        releaseDate: [{required: true, message: "请选择发布日期", trigger: "blur"}],
        noticeType: [{required: true, message: "请选择类型", trigger: "blur"}],
      },
      multipleSelection:[],
      editorOption: {
        placeholder: '请输入内容',
        modules: {
          ImageExtend: {
            loading: true,
            name: 'file',
            action: '',
            response: (res) => {
              if (res.success) {
                return res.entity
              }
            }
          },
          toolbar: {
            container: container,
            handlers: {
              'image': function () {
                QuillWatch.emit(this.quill.id)
              }
            }
          }
        }
      },
      uploadApiUrl:''
    }
  },
  created() {
    this.uploadApiUrl = baseURL + '/file/uploadUserHeadImg'
    this.editorOption.modules.ImageExtend.action = this.uploadApiUrl
    this.getList()
  },
  methods: {
    uploadSuccess(res) {  //把已经上传的图片显示回富文本编辑框中
      //res返回的格式是{url:"图片的路径"}，这个是后台接口返回的
      let quill = this.$refs.myQuillEditor.quill
      quill.focus();
      quill.insertEmbed(quill.getSelection().index, 'image', res.entity);
    },
    searchBtn() {
      this.getList();
    },
    addBtn() {
      this.ruleForm = {
        id: null,
        title: '',
        content: '',
        sign: '',
        releaseDate: '',
        noticeType: ''
      }
      this.dialogTitle = '新增'
      this.addDialogState = true
    },
    resetBtn() {
      this.specialName = null
      this.examineStatus = null
      this.getList();
    },
    viewBtn(row){
      this.ruleForm.title = row.title
      this.ruleForm.content = row.content
      this.ruleForm.sign = row.sign
      this.ruleForm.releaseDate = row.release_date
      this.ruleForm.noticeType = row.notice_type
      this.dialogTitle = '详情'
      this.addDialogState = true
    },
    editBtn(row) {
      this.ruleForm.id = row.id
      this.ruleForm.title = row.title
      this.ruleForm.content = row.content
      this.ruleForm.sign = row.sign
      this.ruleForm.releaseDate = row.release_date
      this.ruleForm.noticeType = row.notice_type
      this.dialogTitle = '修改'
      this.addDialogState = true
    },
    navTo(row) {
      this.$router.push({
        path: "/thematicTagList", query: {
          id: row.id,
          specialName: row.special_name
        }
      });
    },
    deleteBtn(row) {
      this.simpleDelete = true
      this.deleteId = row.id
      this.deleteDialogState = true
    },
    batchDeleteBtn() {
      this.simpleDelete = false
      this.deleteDialogState = true
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    addCancel() {
      this.addDialogState = false
      this.$refs.ruleForm.clearValidate();
    },
    addSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === '新增') {
            this.ruleForm.releaseDate = moment(this.ruleForm.releaseDate).format('yyyy-MM-DD')
            this.postAxios("/notice/addNotice", this.ruleForm).then(res => {
              this.$message.success("添加成功!")
              this.addDialogState = false
              this.getList()
            })
          } else if (this.dialogTitle === '修改') {
            this.ruleForm.releaseDate = moment(this.ruleForm.releaseDate).format('yyyy-MM-DD')
            this.postAxios("/notice/updNoticeById",  this.ruleForm).then(res => {
              this.$message.success("修改成功!")
              this.addDialogState = false
              this.getList()
            })
          }else{
            this.addDialogState = false
          }
        }
      });
    },
    getList() {
      this.postAxios("/notice/getListNotice", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then(res => {
        if (res.success) {
          this.tableData = []
          this.tableData = res.content
          this.totalElements = res.totalCount
        } else {
          this.tableData = []
        }
      });
    },
    deleteSubmit() {
      if (this.simpleDelete) {
        //单个删除
        this.postAxios("/notice/delNoticeByIds", [
            this.deleteId
        ]).then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.getList()
          }
        })
      }else{
        //多个删除
        let ids = []
        this.multipleSelection.forEach((item) => {
          ids.push(item.id)
        })
        this.postAxios("/notice/delNoticeByIds", ids).then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.getList()
          }
        })
      }
    },
    deleteCancel() {
      this.deleteDialogState = false
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
  }
}
</script>

<style scoped>

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 200px;
  height: 100px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}

.avatar {
  width: 200px;
  height: 100px;
  display: block;
}
</style>
